import { 
        GET_MARKET_SHARE_DATA,MARKET_SHARE_DATA_REQUEST, MARKET_SHARE_DATA_SUCESS,
        SET_MARKET_SHARE_DATA, 
       MARKET_SHARE_DATA_FAILED, FETCH_SOS_CLAIM_EVENT_DATA_REQUEST, GET_SOS_CLAIM_EVENT_DATA_SUCCESS, GET_SOS_CLAIM_EVENT_DATA_FAILURE, GET_SOS_CLAIM_EVENT_DATA, GET_SOS_PROGRAM_DATA, GET_FOOTER_DATE, IS_LOADING } from './actionTypes';

export const fetchSoSApiDataRequest = (payload: any) => ({
      type: FETCH_SOS_CLAIM_EVENT_DATA_REQUEST,
      payload
});

export const fetchSoSDataSuccess = (payload: any) => ({
      type: GET_SOS_CLAIM_EVENT_DATA_SUCCESS,
      payload
});
export const fetchSoSDataError = (payload: any) => ({
      type: GET_SOS_CLAIM_EVENT_DATA_FAILURE,
      payload
});

export const getSoSData = (payload: any) => ({
      type: GET_SOS_CLAIM_EVENT_DATA,
      payload
});

export const getfooterDate = (payload: any) => ({
      type: GET_FOOTER_DATE,
      payload
});

export const isLoading = (payload: any) => ({
      type: IS_LOADING,
      payload
});



//market share data for trend graph

export const fetchMarketShareData = (payload: any) => ({
      type: MARKET_SHARE_DATA_REQUEST,
      payload
});

export const marketShareDataSuccess = (payload: any) => ({
      type: MARKET_SHARE_DATA_SUCESS,
      payload
});
export const marketShareDataFail = (payload: any) => ({
      type: MARKET_SHARE_DATA_FAILED,
      payload
});

export const setMarketShareData = (payload: any) => ({
      type: SET_MARKET_SHARE_DATA,
      payload
});

export const getMarketShareData = (payload: any) => ({
      type: GET_MARKET_SHARE_DATA,
      payload
});


